import { ApiService } from '@/services/api.service';
import router from '@/router';

export default {
  state: {
    loginInfo: null,
    user: {},
    token: null,
  },
  mutations: {
    SET_AUTH_TOKEN: (state, data) => {
      if (data) {
        localStorage.setItem('stellantis-token', data.token);
        state.token = data.token;
        ApiService.setAuth(data.token);
      } else {
        localStorage.setItem('stellantis-token', null);
      }
    },
    UPDATE_AUTH: (state, data) => {
      if (data) {
        state.loginInfo = data;
        state.token = data.token;
        ApiService.setAuth(state.token);
      }
    },
    SET_LOGIN_INFO: (state, loginInfo) => {
      localStorage.setItem('stellantis-user', JSON.stringify(loginInfo));
      localStorage.setItem('stellantis-token', loginInfo.token);
      state.loginInfo = loginInfo;
    },
    PURGE_AUTH: (state) => {
      localStorage.removeItem('stellantis-token');
      state.loginInfo = null;
      state.user = {};
    },
    SET_USER: (state, newUser) => {
      state.user = newUser;
    },
  },
  actions: {
    getLoginInfo: ({ commit }, token) =>
      new Promise((resolve, reject) => {
        ApiService.post(`/users/auth?token=${token}`)
          .then((res) => {
            commit('SET_AUTH_TOKEN', res.data.user);
            commit('SET_LOGIN_INFO', res.data.user);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      }),
    devLogin: ({ commit }, { entityParam, uidParam, role, roleDomain, bc, serviceDistrict, salesDistrict }) =>
      new Promise((resolve, reject) => {
        ApiService.post('/users/auth', {
          entity: entityParam,
          uid: uidParam,
          role,
          roleDomain,
          bc,
          serviceDistrict,
          salesDistrict,
        })
          .then((res) => {
            commit('SET_AUTH_TOKEN', res.data.user);
            commit('SET_LOGIN_INFO', res.data.user);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      }),
    checkStorageAuth: ({ commit }, data) => {
      commit('UPDATE_AUTH', data);
    },
    getRoles: () =>
      new Promise((resolve, reject) => {
        ApiService.get('/roles')
          .then((data) => {
            resolve(data.data.roles);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    logout: ({ dispatch }) =>
      new Promise((resolve, reject) => {
        ApiService.post('/users/logout')
          .then(() => {
            dispatch('noAuth');
            resolve();
          })
          .catch((error) => {
            dispatch('noAuth');
            reject(error);
          });
      }),
    noAuth({ commit }) {
      localStorage.removeItem('stellantis-token');
      localStorage.removeItem('stellantis-user');
      localStorage.removeItem('stellantis-language');
      if (process.env.VUE_APP_DEPLOY_ENV === 'qa') {
        window.location = 'https://stagdealerconnect.extra.chrysler.com';
      } else if (process.env.VUE_APP_DEPLOY_ENV === 'prod') {
        window.location = 'https://dealerconnect.chrysler.com';
      } else {
        commit('PURGE_AUTH');
        router.push('/login');
      }
    },
  },
};
